<template>
  <div class="mx-2 mb-2">
    <b-row>
      <b-col cols="12" class="d-flex align-items-center justify-content-center justify-content-sm-end">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number
                      class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18"/>
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18"/>
          </template>
        </b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BPagination, BRow, BCol} from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'

export default {
  props: ['page', 'totalRows', 'perPage'],
  components: { BPagination, BRow, BCol },
  setup(props, {emit}) {

    const currentPage = ref(1)
    watch(currentPage, page => emit('update:page', page))

    return {currentPage}
  }
}
</script>

<style scoped>
</style>
